import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/** Indicador circular SVG de porcentaje (0–100), usado en el dashboard. */
@Component({
  selector: 'app-circular-progress',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center gap-2">
      <svg viewBox="0 0 48 48" [style.width.px]="size" [style.height.px]="size">
        <circle cx="24" cy="24" r="20" [attr.fill]="backgroundColor" />
        <path [attr.d]="sectorPath" [attr.fill]="fill" />
      </svg>
      @if (showPercentage) {
        <span class="text-xs font-semibold"> {{ value }} % </span>
      }
    </div>
  `,
})
export class CircularProgressComponent implements OnChanges {
  @Input() value: number = 0;
  @Input() size: number = 24;

  @Input() backgroundColor: string = '#e2e8f0';
  @Input() fill: string = 'var(--primary-color';
  @Input() showPercentage: boolean = true;

  @Input() radius: number = 20;
  @Input() centerX: number = 24;
  @Input() centerY: number = 24;

  sectorPath: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.updatePath();
    }
  }

  private updatePath() {
    const percent = Math.min(100, Math.max(0, this.value));

    if (percent === 0) {
      this.sectorPath = '';
      return;
    }

    if (percent === 100) {
      this.sectorPath = `M 24 4 A 20 20 0 1 1 24 44 A 20 20 0 1 1 24 4 Z`;
      return;
    }

    const angle = (percent / 100) * 2 * Math.PI;

    const endX = 24 + 20 * Math.sin(angle);
    const endY = 24 - 20 * Math.cos(angle);

    const largeArcFlag = percent > 50 ? 1 : 0;

    this.sectorPath = `M 24 24 L 24 4 A 20 20 0 ${largeArcFlag} 1 ${endX} ${endY} Z`;
  }
}
